import FieldRenderer from '../FieldRenderer';
import ModuleCard from '../ModuleCard';
import { openExternal } from '../../lib/liff';
import { IconMapPin, IconExternal } from '../Icons';

interface ShippingModuleProps {
  module: {
    id: string;
    name: string;
    nameEn?: string;
    fields: any[];
    settings: {
      pickupLocation?: string;
      pickupLocationUrl?: string;
      pickupNote?: string;
    };
  };
  event: any;
}

export default function ShippingModule({ module }: ShippingModuleProps) {
  const settings = module.settings || {};

  return (
    <ModuleCard title={module.name}>
      {settings.pickupLocation && (
        <div className="flex items-start gap-3 p-4 rounded-card bg-soft">
          <span className="w-9 h-9 shrink-0 rounded-[12px] bg-white text-primary inline-flex items-center justify-center"><IconMapPin size={18} /></span>
          <div className="flex-1 min-w-0 flex flex-col gap-0.5 leading-snug">
            <span className="text-[13px] font-bold text-muted">自取地點</span>
            <span className="text-[15px] font-bold">{settings.pickupLocation}</span>
            {settings.pickupNote && <span className="text-xs text-muted">{settings.pickupNote}</span>}
            {settings.pickupLocationUrl && (
              <button type="button" onClick={() => openExternal(settings.pickupLocationUrl!)} className="mt-1.5 inline-flex items-center gap-1 self-start text-[13px] font-bold text-primary">
                開啟地圖 <IconExternal size={14} />
              </button>
            )}
          </div>
        </div>
      )}
      {module.fields?.map((field) => <FieldRenderer key={field.id} field={field} />)}
    </ModuleCard>
  );
}
